import { ApiResponse, FormStore, GlobalStore } from "@roc/feature-app-core";
import { LoanService } from "@roc/feature-loans";
import { generateUUID, LoanSubType, propertyStates } from "@roc/feature-utils";
import { computed, flow, makeObservable } from "mobx";
import { mapPropertyFields } from "../../utils/utils";


const initialForm = {
  fields: {
    propertyType: {
      value: '',
      error: null,
      rule: 'required',
      message: '',
    },
    numberOfProperties: {
      value: '',
      error: null,
      rule: 'required',
      message: '',
    },
    estimatedAsIsValue: {
      value: '',
      error: null,
      rule: 'required',
      message: '',
    }
  },
  meta: {
    key: null,
    editMode: false,
    isValid: false,
    error: null,
  },
};


export class PropertyTypeFormStore extends FormStore {
  private globalStore: GlobalStore;

  public key = generateUUID();

  constructor(globalStore) {
    super(initialForm, globalStore);
    this.globalStore = globalStore;

    makeObservable(this, {
    });
  }

  reset() {
    super.reset();
  }

  getProperty() {
    const property = this.getFormValues();
    return {
      ...property,
      uuid: this.key,
    };
  }
}